// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    analytics: `${ROOTS.DASHBOARD}/analytics`,
    graphs: {
      detail: (sportId: string, eventId: string) => `${ROOTS.DASHBOARD}/graph/${sportId}/${eventId}`,
    },
    bets: {
      root: `${ROOTS.DASHBOARD}/bets`,
      casino: `${ROOTS.DASHBOARD}/bets/casino`,
      previous: `${ROOTS.DASHBOARD}/bets/previous`,
      detail: (betId: string) => `${ROOTS.DASHBOARD}/bets/${betId}`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      CA_users: {
        root: `${ROOTS.DASHBOARD}/users/ca_users`,
        add: `${ROOTS.DASHBOARD}/users/ca_users/add`,
        edit: (admin_id: string) => `${ROOTS.DASHBOARD}/users/ca_users/edit/${admin_id}`,
        detail: (admin_id: string) => `${ROOTS.DASHBOARD}/users/ca_users/detail/${admin_id}`,
      },
      clients: {
        root: `${ROOTS.DASHBOARD}/users/clients`,
        detail: (user_id: string) => `${ROOTS.DASHBOARD}/users/clients/detail/${user_id}`,
      },
      super_admins: {
        root: `${ROOTS.DASHBOARD}/users/super_admins`,
        listing: `${ROOTS.DASHBOARD}/users/super_admins/list`,
        add: `${ROOTS.DASHBOARD}/users/super_admins/add`,
        detail: (admin_id: string) => `${ROOTS.DASHBOARD}/users/super_admins/detail/${admin_id}`,
        edit: (admin_id: string) => `${ROOTS.DASHBOARD}/users/super_admins/edit/${admin_id}`,
      },
    },

    transfer: `${ROOTS.DASHBOARD}/transfer`,

    transferstatement: `${ROOTS.DASHBOARD}/transferstatement`,

    all_logs: {
      root: `${ROOTS.DASHBOARD}/all_logs`,
      session_logs: `${ROOTS.DASHBOARD}/all_logs/session`,
      multiple_ip_logs: `${ROOTS.DASHBOARD}/all_logs/multiple_ip`,
      error_logs: `${ROOTS.DASHBOARD}/all_logs/error`,
      activity_logs: `${ROOTS.DASHBOARD}/all_logs/activity`,
    },

    casino_cms: `${ROOTS.DASHBOARD}/casino_cms`,

    notification: `${ROOTS.DASHBOARD}/site_notications`,

    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
      master_controller: `${ROOTS.DASHBOARD}/settings/master_controller`,
      templates: `${ROOTS.DASHBOARD}/settings/templates`,
      whiteLabel: `${ROOTS.DASHBOARD}/settings/sites`,
      newWhiteLabel: `${ROOTS.DASHBOARD}/settings/sites/add`,
      editWhiteLabel: (id: string) => `${ROOTS.DASHBOARD}/settings/sites/edit/${id}`,
      businessGroups: (businessId: string) => `${ROOTS.DASHBOARD}/settings/sites/${businessId}/groups`,
      bet_highlight_amount: `${ROOTS.DASHBOARD}/settings/bet_highlight_amount`,
      templates_banners: (template_id: string) => `${ROOTS.DASHBOARD}/settings/template/${template_id}`,
      template_groups: (template_id: string) => `${ROOTS.DASHBOARD}/settings/templates/${template_id}/groups`,
      change_passcode: `${ROOTS.DASHBOARD}/settings/change_passcode`,
    },
    developer: {
      root: `${ROOTS.DASHBOARD}/developer`,
      maintenance: `${ROOTS.DASHBOARD}/developer/maintenance`,
      dev_tools: `${ROOTS.DASHBOARD}/developer/dev_tools`,
    },
    sites: {
      list: `${ROOTS.DASHBOARD}/sites/list`,
    },

    surveillance: `${ROOTS.DASHBOARD}/surveillance`,
    maintenance: `${ROOTS.DASHBOARD}/maintenance`,
    sports: {
      root: `${ROOTS.DASHBOARD}/sports`,
      detail: (sportId: string, eventId: string) => `${ROOTS.DASHBOARD}/sports/${sportId}/${eventId}`,
    },
    casino: `${ROOTS.DASHBOARD}/casino`,
    groups: {
      root: `${ROOTS.DASHBOARD}/groups`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/groups/edit/${id}`,
    },
  },
};
